import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      name: 'home',
      component: () =>
        import ('./views/Home.vue'),
      children: [{
        path: '/',
        component: () =>
          import ('./components/AppPanel.vue')
      }, {
        name:'employeelist',
        path: 'employees',
        component: () =>
          import ('./components/apps/EmployeeList.vue')
      }, {
        name:'transexp_control',
        path: 'transexp_control',
        component: () =>
          import ('./components/apps/CtrlTransExp.vue')
      }, {
        name:'workinghours_control',
        path: 'workinghours_control',
        component: () =>
          import ('./components/apps/CtrlWorkingHours.vue')
      }, {
        name:'info',
        path: 'info',
        component: () =>
          import ('./components/apps/Info.vue')
      }, {
        name: 'edit',
        path: 'edit',
        props: true,
        component: () =>
          import ('./components/apps/EditInfo.vue')
      }, {
        name: 'transexp',
        path: 'transexp',
        props: true,
        component: () =>
          import ('./components/apps/TransExp.vue')
      }, {
        name: 'workinghours',
        path: 'workinghours',
        props: true,
        component: () =>
          import ('./components/apps/WorkingHours.vue')
      }, {
        name: 'create_employee',
        path: 'create_employee',
        props: true,
        component: () =>
          import ('./components/apps/CreateEmployee.vue')
      }, {
        name: 'change_password',
        path: 'change_password',
        props: true,
        component: () =>
          import ('./components/apps/ChangePassword.vue')
      }, {
        name: 'test',
        path: 'test',
        props: true,
        component: () =>
          import ('./components/apps/Test.vue')
      }]
    }, {
      path: '/login',
      name: 'login',
      component: () =>
        import ('./views/Login.vue')
    }, {
      path: '/forgotpassword',
      name: 'forgotpassword',
      component: () =>
        import ('./views/ForgotPassword.vue')
    }, {
      path: '/resetpassword/:token',
      name: 'resetpassword',
      component: () =>
        import ('./views/ResetPassword.vue')
    }, {
      path: '/calendarlink',
      name: 'calendarlink',
      beforeEnter() {location.href = 'https://calendar.google.com/calendar/embed?src=4j0qto6pus025fg26b397lfb10%40group.calendar.google.com&ctz=Asia%2FTokyo'}
    }
    // {
    //   path: '/dashboard',
    //   name: 'dashboard',
    //   component: () =>
    //     import ('./views/Dashboard.vue'),
    //   children: [{
    //       path: '/',
    //       component: () =>
    //         import ('./components/dashboard/Profile.vue')
    //     },
    //     {
    //       path: 'employees',
    //       component: () =>
    //         import ('./components/dashboard/Employees.vue')
    //     },
    //     {
    //       path: 'authorization',
    //       component: () =>
    //         import ('./components/dashboard/Authorization.vue')
    //     },
    //     {
    //       path: 'editprofile',
    //       name: "editprofile",
    //       component: () =>
    //         import ('./components/dashboard/EditProfile.vue'),
    //       props: true
    //     }
    //   ]
    // }
  ]
})
